export const styles = theme => ({
    submitPassBtn: {
        bottom: '16px',
        right: '0',
        left: '0',
    },
    loading: {
        ...theme.typographyPresets.titleMediumBold,
    },
    infoModalContainer: {
        padding: '30px',
        textAlign: 'center',
        maxWidth: '400px',
    },
    infoModalHeadline: {
        ...theme.typographyPresets.titleMediumBlack,
    },
    infoModalSubheadline: {
        ...theme.typographyPresets.titleSmall,
    },
    infoModalBtn: {
        marginBottom: '10px',
    },
    infoModalClose: {
        ...theme.modalClose,
    },
    signInLink: {
        ...theme.typographyPresets.bodySecondaryLight,
        fontFamily: theme.typographyPresets.fonts.notoSans.regular,
        cursor: 'pointer',
        textDecoration: 'underline',
        marginBottom: 32,
        border: 0,
        background: 0,
    },
    title: {
        fontFamily: theme.typographyPresets.fonts.monserrat.regular,
        fontSize: 11,
        color: '#a7a7a7',
        marginBottom: 12,
    },
    paywallHeading: {
        fontFamily: theme.typographyPresets.fonts.notoSans.bold,
        fontSize: 14,
        fontWeight: 'bold',
        textTransform: 'uppercase',
        fontStyle: 'normal',
        marginBottom: 14,
        position: 'relative',
    },
    pass: {
        display: 'flex',
        alignItems: 'center',
        marginBottom: 24,
        position: 'relative',
    },
    passContent: {
        flex: 1,
    },
    passImg: {
        width: 60,
        height: 60,
        borderRadius: 8,
        objectFit: 'cover',
        marginRight: 16,
        boxShadow: '1px 1px 3px rgba(0, 0, 0, 0.3)',
    },
    feeBreakdown: {
        display: 'flex',
        justifyContent: 'space-between',
        marginTop: 15,
    },
    passTitle: {
        fontSize: 16,
        fontFamily: theme.typographyPresets.fonts.monserrat.bold,

        '&::after': {
            fontFamily: theme.typographyPresets.fonts.monserrat.regular,
            content: '"x 1"',
            fontSize: 14,
            fontWeight: 'normal',
            position: 'absolute',
            right: 0,
        },
    },
    total: {
        fontSize: 16,
        fontFamily: theme.typographyPresets.fonts.monserrat.bold,
        margin: 0,
    },
    passAmount: {
        fontFamily: theme.typographyPresets.fonts.monserrat.bold,
        fontSize: 16,
        color: '#4a5775',
    },
    description: {
        fontSize: 12,
        fontFamily: theme.typographyPresets.fonts.monserrat.regular,
        marginBottom: -1,
        paddingRight: 5,
        backgroundColor: theme.colors.light.offWhite2,
    },
    descriptionAmount: {
        fontSize: 12,
        fontFamily: theme.typographyPresets.fonts.monserrat.regular,
        backgroundColor: theme.colors.light.offWhite2,
        paddingLeft: 5,
    },
    descriptionLine: {
        margin: -5,
        width: '95%',
    },
    paymentInfo: {
        marginBottom: 35,
    },
    underline: {
        borderBottom: `1px solid ${theme.colors.light.lightGray2}`,
    },
    '@media (max-width: 767px)': {
        paywallSubheading: {
            ...theme.typographyPresets.titleSmall,
        },

        renderBtn: {
            marginBottom: '16px',
        },
        paywallSubmitBtn: {
            position: 'relative',
            margin: '16px 0',
            bottom: '0',
            width: '100% !important',
        },
        paper: {
            width: '320px',
        },
    },
    '@media (min-width: 768px)': {
        paywallSubheading: {
            ...theme.typographyPresets.titleSmallLight,
            fontSize: 14,
        },
        paywallSubmitBtn: {
            position: 'initial',
            margin: '16px 0',
            bottom: '0',
            width: '100% !important',
        },
        signInLink: {
            fontSize: 12,
        },
    },
    paragraph: {
        ...theme.typographyPresets.bodyTertiary,
    },
})
